import { render, staticRenderFns } from "./cabeceraPedido.vue?vue&type=template&id=c190f49e&scoped=true"
import script from "./cabeceraPedido.vue?vue&type=script&lang=js"
export * from "./cabeceraPedido.vue?vue&type=script&lang=js"
import style0 from "./cabeceraPedido.vue?vue&type=style&index=0&id=c190f49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c190f49e",
  null
  
)

export default component.exports